import { t } from 'i18next';
import { DEFAULT_CURRENCY } from '../../../constants/currency';

/**
 * Format a plan's price for display. `null` is used to represent a plan with
 * no fixed price (e.g. enterprise), and is rendered as a localised "Custom"
 * label.
 */
export function formatPlanPrice(price: number | null): string {
  if (price === null) {
    return t('features:billing.components.plan_card.price.custom');
  }

  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: DEFAULT_CURRENCY,
    maximumFractionDigits: 0,
  }).format(price);
}
